import { render, staticRenderFns } from "./Dots.vue?vue&type=template&id=756a63c2&scoped=true&lang=pug&"
import script from "./Dots.vue?vue&type=script&lang=js&"
export * from "./Dots.vue?vue&type=script&lang=js&"
import style0 from "./Dots.vue?vue&type=style&index=0&id=756a63c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "756a63c2",
  null
  
)

export default component.exports